import React from 'react';
import {BadgeContainer, IconContainer} from './styles';
import {BsFillPeopleFill} from 'react-icons/bs';

export default ({
  color = '#afafaf',
  text,
  size = '32px',
  font = '14px',
  family = 'Bree Serif',
  weight = '400',
  checked = false,
  initial = false,
}: {
  icon?: string;
  text?: string;
  size?: string;
  font?: string;
  color?: string;
  family?: string;
  weight?: string;
  initial?: boolean;
  checked?: boolean;
}) => (
  <BadgeContainer text={text} color={color} size={size} font={font} family={family} weight={weight} checked={checked}>
    {text !== 'NULL' ? (
      <>
        {text ? (
          <span> {text} </span>
        ) : initial ? (
          <span className="initial">INITIALS PENDING</span>
        ) : (
          <IconContainer>
            <BsFillPeopleFill />
          </IconContainer>
        )}
      </>
    ) : (
      <></>
    )}
  </BadgeContainer>
);
